module.exports = __webpack_public_path__ + "img/sam-shirt-pride-04.6f312570.jpg";